module.exports = __webpack_public_path__ + "static/media/minus.57a3448d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/minus.svg
// module id = 734
// module chunks = 0